var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.946 8.856",
    height: 33.471,
    width: 37.59,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99,
      fill: "#000",
      stroke: "none",
      strokeWidth: 3.85175,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M505.663 253.913h597.809c19.845 0 56.137 29.95 56.137 67.154v501.577c0 37.204-42.387 67.154-62.232 67.154H507.694c-19.845 0-62.232-29.95-62.232-67.154V321.067c0-37.203 40.355-67.154 60.2-67.154z",
    transform: "matrix(.01393 0 0 .01393 -6.204 -3.536)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "DussoU",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "750.084px",
      lineHeight: 1.25,
      fontFamily: "Haettenschweiler",
      InkscapeFontSpecification: "Haettenschweiler",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.07199,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.995 839.245V314.04h143.57q46.881 0 83.506 25.637 36.625 25.272 36.625 78.012v317.907q0 49.077-34.427 76.546-34.062 27.103-84.97 27.103zm147.6-95.226V409.265q0-27.469-32.23-27.469v390.059q32.23 0 32.23-27.836zM1045.427 839.245H941.41V824.96q-20.144 20.144-64.46 20.144-30.765 0-53.473-16.115-22.341-16.482-22.341-42.852V414.026h104.015v345.742q0 19.412 18.313 19.412 17.946 0 17.946-18.68V414.027h104.016z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontFamily: "Haettenschweiler",
      InkscapeFontSpecification: "Haettenschweiler",
      fill: "#fff",
      stroke: "none",
      strokeWidth: 7.07199,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "matrix(.01416 0 0 .0137 -6.204 -3.536)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f07c00",
      fillRule: "evenodd",
      stroke: "#f07c00",
      strokeWidth: 0.396894,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none"
    },
    d: "M797.65 334.473v15.423c0 21.36.229 21.403 10.752 21.013h242.971c11.9 0 11.198-.284 11.198-21.91v-15.424c0-19.861.702-20.114-9.674-20.114H811.15c-13.662-.18-13.5-.188-13.5 21.012z",
    transform: "matrix(.01393 0 0 .01393 -6.204 -3.536)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.6d63894ae56186828d7c4efbf43193cd.svg";
export { ForwardRef as ReactComponent };